import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from '../../Common/Images/ImagesForAlert/popup_bg2.png';
import popclose from "../../Common//Images/ImagesForAlert/popup_close_n.png";
import Loading from '../../Common/Loading';

interface Question {
  Strand: string;
  SubStrand: string;
  Yr: string;
  Topic: string;
  QnNo: string;
  LessonCode: string;
  QnFileName: string;
  QnCatg: string;
  Remarks?: string;
}

interface Country {
  value: string;
  label: string;
}

const MD_ExceptionError: React.FC = () => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [questions, setQuestions] = useState<Question[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;


  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}api/get_countries2_for_mdexception/`);
      const data = await response.json();

      const countryNames: Country[] = Array.isArray(data?.countries)
        ? data.countries
        : [];

      setCountries(countryNames);
    } catch (error) {
      setErrorMessage('Failed to fetch countries. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchQuestions = async (country: string) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}api/questions/?country=${country}`);
      const data = await response.json();
      setQuestions(Array.isArray(data) ? data : []);
    } catch (error) {
      setErrorMessage('Failed to fetch questions. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };


  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedCountry(e.target.value);
    if (e.target.value) {
      fetchQuestions(e.target.value);
    }
  };

  const handleBackClick = () => {
    navigate('/support/dashboard');
  };

  return (
    <div style={{
      fontFamily: "Times New Roman",
      margin: '0',
      padding: '0',
      backgroundColor: '#f0f0f0',
      height: '100vh',
      overflow: 'hidden'
    }}>
      {isLoading && <Loading />}
      {/* Header */}
      <div style={{
        backgroundImage: `url(${popimg}), url(${popbg})`,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundPosition: 'left center, right center',
        backgroundSize: '30% 100%, 70% 100%',
        height: '16px',
        color: 'white',
        padding: '7px 0px',
        fontWeight: 'bold',
        fontSize: '12pt',
        fontFamily: 'arial',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <span style={{ marginLeft: "10px" }}>MD Exceptions</span>
        <img src={popclose} alt="close" height="30px" style={{ cursor: "pointer" }} onClick={() => navigate('/SysAdmin')} />
      </div>

      {/* Main Content */}
      <div style={{
        padding: '10px',
        height: 'calc(100vh - 30px)',
        overflow: 'hidden',
        backgroundColor: "azure"
      }}>
        {/* Title and Controls */}
        <div style={{
          marginBottom: '5px',
          textAlign: "center"
        }}>
          <div style={{ fontWeight: 'bold', fontSize: '14pt', marginBottom: "3px", fontFamily: "arial" }}>
            <span style={{ textAlign: "center" }}> MathsDoctor Data Exceptions</span>
          </div>
          <div style={{ fontFamily: "arial", fontSize: "12pt", textAlign: "left" }}>
            Country:
            <select
              value={selectedCountry}
              onChange={handleCountryChange}
              style={{
                marginLeft: '5px',
                padding: '1px',
                border: '1px solid #8a8a8a',
                borderRadius: '3px',
                cursor: 'pointer'
              }}
            >
              <option value="">--Select--</option>
              {countries.map((country, index) => (
                <option key={index} value={country.label}>
                  {country.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Data Table (Conditionally Rendered) */}
        {questions.length > 0 && (
          <div style={{
            height: 'calc(100vh - 160px)',
            overflow: 'auto',
            border: '1px solid #80a0ff',
            backgroundColor: 'white'
          }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '13tx',
              border: "1px solid #80a0ff"
            }}>
              <thead style={{ position: 'sticky', width: "100vw", top: '0px', border: "1px solid #80a0ff" }}>
                <tr style={{ backgroundColor: '#c7ddfd', border: "1px solid #80a0ff" }}>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '40px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>#</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '100px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>Strand</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '100px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>SubStrand</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '60px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>Yr</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '100px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>Topic</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '80px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>QnNo</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '120px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>LessonCode</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '200px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>QnFileName</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'center',
                    width: '80px',
                    fontWeight: 'normal',
                    color: "#2859ac"
                  }}>QnCatg</th>
                  <th style={{
                    padding: '8px',
                    textAlign: 'left',
                    width: '1500px',
                    fontWeight: 'normal',
                    color: "#2859ac",
                  }}>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {questions.map((question, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? '#f4faff' : 'white',
                      height: '30px'
                    }}
                  >
                    <td style={{ padding: '0px', textAlign: 'center' }}>{index + 1}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.Strand}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.SubStrand}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.Yr}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.Topic}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.QnNo}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.LessonCode}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.QnFileName}</td>
                    <td style={{ padding: '0px', textAlign: 'center' }}>{question.QnCatg}</td>
                    <td style={{
                      padding: '0px',
                      textAlign: 'left',
                      color: question.Remarks === "Not used in DB" ? 'red' : 'inherit'
                    }}>{question.Remarks || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {errorMessage && (
        <div style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          backgroundColor: '#ffebee',
          color: '#d32f2f',
          padding: '10px',
          borderRadius: '4px',
          border: '1px solid #ef9a9a',
          fontSize: '14px'
        }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default MD_ExceptionError;
